var defaultCommonData = {
  pittsTFN: {
    pageID: ['deposits/accounts', 'deposits/checking-accounts', 'deposits/interest-checking-account', 'deposits/interest-checking-account-bya', 'deposits/personal-checking-account', 'deposits/personal-checking-account-bya', 'deposits/safebalance-bank-account', 'deposits/safebalance-bank-account-bya', 'deposits/savings-accounts', 'deposits/rewards-mms-bya', 'deposits/checking-debit-cards'],
    zipLow: '15001',
    zipHigh: '16263',
    phone: '800.203.9872'
  }
};

const importData = defaultCommonData;
const pilotPagesToUpdate = importData.pittsTFN.pageID;
const zipLow = importData.pittsTFN.zipLow;
const zipHigh = importData.pittsTFN.zipHigh;
const phone = importData.pittsTFN.phone;
let spartaGetCookie = name => {
  let returnvalue = '';
  const search = `${name}=`;
  if (document.cookie.length > 0) {
    let offset = document.cookie.indexOf(search);
    if (offset !== -1) {
      offset += search.length;
      let end = document.cookie.indexOf(';', offset);
      if (end === -1) {
        end = document.cookie.length;
      }
      returnvalue = unescape(document.cookie.substring(offset, end));
    }
  }
  return returnvalue;
};
const currentPage = spaParams.siteName + "/" + (spaParams.pageParams.pageID || ""); //grab current site/page ID
const currentZip = spartaGetCookie("boa_geographic_data"); // grab the cookie
const trimmedZip = currentZip.split("|")[0]; // trim to just 5 digit zip code

class UpdatePhoneOnZip {
  checkPageAgainstPilot() {
    if (trimmedZip >= zipLow && trimmedZip <= zipHigh) {
      const pageFound = pilotPagesToUpdate.find(e => {
        return e === currentPage;
      });
      if (!pageFound) {
        return;
      }
      const numberToUpdate = document.getElementsByClassName('dynamic-phone');
      const mobileNumberToUpdate = document.getElementsByClassName('dynamic-phone-mobile');
      Array.prototype.forEach.call(numberToUpdate, el => {
        el.innerHTML = phone;
      });
      Array.prototype.forEach.call(mobileNumberToUpdate, el => {
        el.href = `tel:${phone}`;
      });
    }
  }
}
var index = new UpdatePhoneOnZip();

export { index as default };
